import * as React from 'react';
import { Select } from 'antd';
import StaticView from './StaticView';
import * as intl from "react-intl-universal";
const Option = Select.Option;

export default class SelectSearch extends React.Component<any> {
    static fieldName = 'select';
    static type = 'Select';
    timeout: any;
    state: any = {
        options: []
    };
    // private tree: HTMLElement;
    /**
     * 值变化控制
     * @param value
     */
    onChangeHandler = (value: any) => {
        const { onChange } = this.props;
        if (onChange) onChange(value);
    };

    /**
     * 选择控制
     * @param value
     */
    onSelectHandler = (value: any) => {
        const { onSelect } = this.props;
        if (onSelect) onSelect(value);
    };

    /**
     * 失焦控制
     */
    onBlurHandler = () => {
        const { onBlur, value } = this.props;
        if (onBlur) onBlur(value);
    };

    onSearchHandler = (value: any) => {
        const { onSearch, callback, role } = this.props;
        // 调取列表，更新option
        if (callback && value) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
            this.timeout = setTimeout(() => {
                this.setState({ options: [] }, () => {
                    this.updateOptions(value, callback, role);
                });
            }, 300);
        }
        if (onSearch) onSearch(value);
    };

    /**
     * 更新options
     */
    updateOptions = (value: any, callback: Function, type?: string | Array<string>) => {
        callback({
            uname: value,
            page: 1,
            pagesize: 20,
            ...(type ? { utype: Array.isArray(type) ? type : [type] } : {})
        }).then(({ data }: any) => {
            const source = data.length ? data : data.concat([{
                uuid: 'None',
                firstName: 'Search',
                lastName: 'nothing',
                disabled: true
            }]);
            this.setState({ options: this.formatOption(source) });
        }).catch();
    };

    /**
     * 格式化options
     */
    formatOption = (options: any) => {
        return options.map(({ uuid, lastname, firstname, disabled }: any) => ({
            label: `${intl.get('Global.Name', {
                firstName: firstname,
                lastName: lastname
            })} (${uuid})`,
            value: uuid,
            disabled: disabled
        }));
    };

    /**
     * 静态数据展示处理
     * @param val
     */
    adaptHandler = (val: any) => {
        const { options } = this.state;
        const { defaultInfo } = this.props;
        defaultInfo && defaultInfo.uuid && !options.filter(({ value }: any) => value == defaultInfo.uuid).length && options.push({
            label: `${intl.get('Global.Name', {
                firstName: defaultInfo.firstname,
                lastName: defaultInfo.lastname
            })} (${defaultInfo.uuid})`,
            value: defaultInfo.uuid
        });
        const display = options && options.filter(({ value }: any) => (val || []).includes(value));
        return (display && display.length) && display[0].label.split(' (')[0];
    };

    /**
     * get tree node description
     * @param treeData
     * @param values
     */
    getTreeDesc = (value: any[]) =>  value && value.join(' / ');

    render() {
        const { placeholder, allowClear, disabled, size, staticView, initialValue, value, mode, readOnly, onDeselect, heightLimit } = this.props;
        const { options } = this.state;
        return (
            (staticView && disabled || readOnly)
                ? <StaticView display={initialValue && this.getTreeDesc(initialValue)} wrap={true}/>
                : <div className={heightLimit ? 'treeSelect' : 'account-type-location-parent'}
                       ref={(ctx: HTMLElement) => this.tree = ctx}
                       style={{ position: 'relative' }}>
                    <Select onChange={this.onChangeHandler}
                          onSelect={this.onSelectHandler}
                          onBlur={this.onBlurHandler}
                          onSearch={this.onSearchHandler}
                          onDeselect={onDeselect}
                          placeholder={placeholder}
                          allowClear={allowClear}
                          disabled={disabled}
                          value={value}
                          size={size}
                          filterOption={false}
                          mode={mode}>
                    {options.length && options.map((item: any, index: number) => {
                        return <Option key={item.value + index} value={item.value} disabled={item.disabled}>
                                {item.label}
                            </Option>;
                    })}
                    </Select>
                </div>
        );
    }
}
